import * as Dialog from '@radix-ui/react-dialog';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import type { PropsWithChildren } from 'react';

import * as styles from './presentation-dialog.css';

export type AttachmentPresentationDialogProps = PropsWithChildren<{
  title: string;
  onClose: () => void;
}>;

/** Keeps attachment presentation isolated from the underlying editor. */
export function AttachmentPresentationDialog({
  title,
  onClose,
  children,
}: AttachmentPresentationDialogProps) {
  return (
    <Dialog.Root
      modal
      open
      onOpenChange={open => {
        if (!open) onClose();
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content
          className={styles.content}
          aria-describedby={undefined}
          onOpenAutoFocus={event => {
            event.preventDefault();
            event.currentTarget
              .querySelector<HTMLElement>(
                '[data-attachment-presentation-close]'
              )
              ?.focus();
          }}
        >
          <VisuallyHidden.Root asChild>
            <Dialog.Title>{title}</Dialog.Title>
          </VisuallyHidden.Root>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
